import styled from 'styled-components';
import { Button } from 'Components';
import { BREAKPOINTS } from 'constants/common';

export const PlanComponent = styled.div<{ amount: number }>`
  width: ${props => `calc(${100 / props.amount}% - 7px)`};
  flex-shrink: 0;

  @media (max-width: 700px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export const RootWrap = styled.div`
  position: relative;
  font-family: Gotham SSm A, Gotham SSm B, Helvetica, Arial, sans-serif;
  padding-top: 32px;

  @media (max-width: ${BREAKPOINTS.desktop - 1}px) {
    padding-top: 24px;
  }
`;

export const Wrap = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  position: relative;

  @media (max-width: 1300px) {
    display: block;
    padding-top: 32px;
  }

  .leftCol {
    width: 300px;
    flex-shrink: 0;

    @media (max-width: 1300px) {
      width: 100%;
    }
  }

  .rightCol {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    width: 100%;

    @media (max-width: 1300px) {
      margin-left: 0;
      margin-top: 30px;
    }

    position: relative;
  }

  .row {
    margin-bottom: 32px;
    &:first-child {
      margin-top: 20px;
    }

    label {
      display: block;
      font-weight: 900;
      font-size: 16px;
      margin-bottom: 12px;
    }
  }

  .switchToMonthlyBilling {
    font-style: italic;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    span {
      margin-left: 5px;
      font-size: 16px;
    }
  }
`;

export const PlanWrap = styled.div`
  display: flex;
  column-gap: 7px;
  margin: 16px 0;

  @media (max-width: 700px) {
    display: block;

    .mobileTooltip {
      font-size: 14px;
      padding: 10px 10px 20px 10px;
      color: white;
      background: #454545;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      position: relative;
      top: 10px;
      z-index: -1;
    }
  }
`;

export const Plan = styled.div<{ selected: boolean; showBilledPerYear: boolean }>`
  position: relative;
  border-radius: 8px;
  border: 2px solid var(--Neutral-N100, #e6e6e6);
  flex: 1;
  padding: 24px 16px;
  height: 100%;
  box-sizing: border-box;
  transition: height 0.2s ease-out;

  ${props =>
    props.selected &&
    `
    border: 2px solid var(--Primary-P500, #4F31FF);
    background: var(--Primary-P25, #FCFAFF);
  `}
`;

export const FeaturesWrap = styled.div``;
export const FeaturesTitle = styled.div`
  color: var(--Text-T01, #333);

  /* Web App/Paragraph 2 Semi Bold */
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  margin-bottom: 8px;
`;
export const Features = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    color: var(--Text-T01, #333);
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    /* Web App/Paragraph 2 Regular */
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */

    svg {
      width: 12px;
      margin-right: 8px;
    }
  }
`;

export const PlanPrice = styled.div<{ selected: boolean }>`
  text-align: center;
  font-size: 16px;
  margin: 8px auto;
  color: #454545;
  display: flex;
  align-items: center;
  justify-content: center;

  h4 {
    color: var(--Text-T01, #333);
    text-align: center;
    margin: 0;

    /* Web App/Heading 3 */
    font-family: Gotham SSm A, Gotham SSm B, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 133.333% */
  }
`;

export const Strikethrough = styled.span`
  text-decoration: line-through;
`;

export const PlanPriceDetail = styled.div`
  margin-left: 4px;
  color: var(--Text-T01, #333);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  /* Text xs/Semibold */
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 150% */
`;
export const BilledPerYear = styled.div`
  color: var(--Text-T01, #333);
  text-align: center;
  margin-bottom: 8px;

  /* Web App/Paragraph 3 Regular */
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`;

export const PlanName = styled.div<{ selected: boolean }>`
  color: ${props => (props.selected ? 'var(--Primary-P500, #4f31ff)' : 'var(--Text-T01, #333);')};
  text-align: center;

  /* Web App/Heading 4 */
  font-family: Gotham SSm A, Gotham SSm B, sans-serif;
  text-transform: capitalize;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`;

export const ButtonWrap = styled.div`
  margin-left: auto;
  margin-top: auto;
  margin-bottom: 150px;

  .noCCRequired {
    display: block;
    text-align: center;
    margin-top: 10px;
    font-style: italic;
    font-size: 12px;
  }
`;

export const ButtonWrapStyled = styled(ButtonWrap)`
  margin-bottom: 50px;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 700px) {
    margin-left: inherit;
  }
`;

export const ButtonStyled = styled(Button)`
  margin-top: 16px;
  margin-left: auto;
  width: 240px;

  @media (max-width: 700px) {
    margin-top: 20px;
    width: 100%;
  }
`;

export const CalendlyLink = styled.p`
  margin-top: 8px;
  font-style: italic;
  line-height: 18px;
  width: 95%;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Breadcrumbs = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  padding: 0;
  align-items: center;

  li {
    margin-right: 10px;
    font-size: 14px;
    a {
      text-decoration: none;
    }
    a:hover {
      opacity: 0.7;
    }
    @media (max-width: 700px) {
      font-size: 12px;
    }
  }
  li:nth-child(3) {
    font-weight: bold;
    color: var(--primary);
  }
  li:nth-child(5) {
    color: black;
  }
  li:nth-child(7) {
    color: black;
  }
`;

export const Subtitle = styled.div`
  width: 256px;
  margin: 8px auto;
  border-radius: 24px;
  background: var(--Primary-P50, #edeaff);
  padding: 2px 8px;
  text-align: center;
  color: var(--Text-T01, #333);

  /* Text sm/Semibold */
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const OptionsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    color: var(--Text-T02, #454545);
    margin: 0 0 4px 0;
    /* Text sm/Medium */
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
  }
`;
export const CurrencyOptions = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
export const CurrencyOptionsWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
export const OptionItem = styled.div<{ active: boolean }>`
  padding: 4px 12px;
  border-radius: 100px;
  cursor: pointer;
  background: ${props =>
    props.active ? `var(--Primary-P500, #4f31ff)` : `var(--Neutral-N50, #F2F2F2)`};
  color: ${props => (props.active ? 'var(--Shade-White, #fff)' : 'var(--Neutral-N500, #808080)')};

  /* Text xs/Semibold */
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 150% */
`;
export const BillingCycleOptions = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;
export const BillingCycleOptionsWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const LinkSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const FullPricingLink = styled.a`
  color: var(--Primary-P500, #4f31ff);
  text-align: right;

  /* Text sm/Medium */
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  text-decoration: none;
  display: flex;
  align-items: center;
  svg {
    margin-left: 4px;
  }
`;

export const PlanSelectedIndicator = styled.div<{ selected: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: ${props =>
    props.selected
      ? '1px solid var(--Primary-P500, #4F31FF)'
      : '1px solid var(--Neutral-N200, #c4c4c4)'};
  background: ${props => (props.selected ? 'var(--Primary-P50, #EDEAFF)' : 'var(--White, #fff)')};
  position: absolute;
  right: 20.667px;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background: ${props =>
      props.selected ? 'var(--Primary-P500, #4F31FF)' : 'var(--White, #fff)'};
  }
`;

export const BilledYearlyCompare = styled.div`
  color: var(--Text-T01, #333);
  text-align: center;

  /* Web App/Paragraph 3 Regular */
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`;

export const SpinnerWrap = styled.div`
  width: 100%;
  height: 270px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PreviousNavWrap = styled.div`
  @media (max-width: ${BREAKPOINTS.tablet}px) {
    margin-left: 16px;
  }
`;
